import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import Description from './Description';

const useStyles = makeStyles((theme: any) => ({
  header: {
    color: theme.palette.brand.greenDark,
    paddingTop: ({ customPadding }: any) =>
      customPadding ? theme.spacing(customPadding) : theme.spacing(2),
    paddingBottom: ({ customPadding }: any) =>
      customPadding ? theme.spacing(customPadding) : theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.brand.greyWhite}`,
  },
  text: {
    textAlign: 'center',
    lineHeight: 1.1666,
    fontWeight: 500,
    color: theme.palette.brand.black,
    whiteSpace: 'break-spaces',
  },
}));

export default function Header({
  header,
  description,
  customPadding,
}: {
  header: string;
  description?: string | React.ReactNode;
  customPadding?: number;
}) {
  const classes = useStyles({ customPadding });
  return (
    <div className={classes.header}>
      <Typography variant="h5" className={classes.text}>
        {header}
      </Typography>
      {description && (
        <Description description={description} isInHeader={true} />
      )}
    </div>
  );
}
